module.exports = __webpack_public_path__ + "static/media/air-conditioner.44d3ea03.svg";